import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { getRequestData } from '@/utils';
import {
  qryOrderInfo4DRMBsnl,
  qryCfsOrder,
  qrySalesInvoiceBsnl,
  qryEnumberList4Staff,
  agentEvoucherQry,
  agentSalesInvoicePay4UserBsnl,
  checkStaffOtpFlag,
} from '@/pages/SalesOrderMgr/services/salesOrderMgr';

export default {
  namespace: 'salesOrderMgr',
  state: {
    step: 0, // 业务步骤
    searchTableData: [], // 订单列表
    total: 0, // 分页总数
    cfsOrdList: [],
    salesInvoiceList: [],
    salesInvoiceAmount: 0,
    topupNumber: '', // 充值号码
    topupBalance: '', // 充值余额
    displayTopupBalance: '', // 展示的余额
    selCustOrder: {}, // 当前选择的客户订单
    selOrderItem: {}, // 选择的订户订单, 弹窗展示工单进度
    otpFlag: '', // 充值是否需要发送验证码
  },
  effects: {
    *qryOrderInfo4DRMBsnl({ payload }, { call, put }) {
      const { params } = payload;
      const response = yield call(qryOrderInfo4DRMBsnl, params);
      const result = getRequestData(response);
      const pageIndex = get(params, 'pageReqDto.pageIndex');
      if (pageIndex === 1) { // 只有第一页返回的总数才是真正的总数
        yield put({
          type: 'save',
          payload: {
            total: get(result, 'pageReqDto.totalRecord') || 0,
          },
        });
      }
      // 清洗数据源的key值，增加一个新的key用于表格的key， custOrderNbrKey
      let newTableData = get(result, 'custOrderDtoList');
      if (newTableData && newTableData.length) {
        newTableData = newTableData.map((i, index) => {
          i.custOrderNbrKey = `${index}${i.custOrderNbr}`;
          return i;
        });
      }
      yield put({
        type: 'save',
        payload: {
          searchTableData: newTableData || [],
        },
      });
    },
    // 恒河水是代理商默认一个，所有员工也用同一个，再调用已有查询代理商ENumber余额
    *qryTopupBalance({ payload }, { call, put }) {
      const { staffId, orgId } = payload;
      const response = yield call(qryEnumberList4Staff, staffId);
      const enumberList = getRequestData(response, false);
      if (!isEmpty(enumberList)) {
        const data = yield call(agentEvoucherQry, { agentMSISDN: get(enumberList, ['0', 'enumber']), agentCode: orgId });
        const { evoucherObjList } = getRequestData(data);
        yield put({
          type: 'save',
          payload: {
            topupNumber: get(enumberList, ['0', 'enumber']),
            topupBalance: get(evoucherObjList, ['0', 'balValue']),
            displayTopupBalance: get(evoucherObjList, ['0', 'displayBalValue']),
          },
        });
      }
    },
    *qryCfsOrder({ payload }, { call, put }) {
      const { params } = payload;
      const response = yield call(qryCfsOrder, params);
      const { cfsOrdList } = getRequestData(response, false);
      if (!isEmpty(cfsOrdList)) {
        yield put({
          type: 'save',
          payload: {
            cfsOrdList,
          },
        });
      }
    },
    *qrySalesInvoiceBsnl({ payload }, { call, put }) {
      const { params } = payload;
      const response = yield call(qrySalesInvoiceBsnl, params);
      const { salesInvoiceDtoList } = getRequestData(response, false);
      if (!isEmpty(salesInvoiceDtoList)) {
        // 计算出所有的未出帐金额
        let salesInvoiceAmount = 0;
        salesInvoiceDtoList.forEach(item => {
          // 状态，'1'、未出帐， '9' 已缴费
          if (item.state === '1') {
            salesInvoiceAmount += parseInt(item.due || 0, 10);
          }
        });
        yield put({
          type: 'save',
          payload: {
            salesInvoiceList: salesInvoiceDtoList,
            salesInvoiceAmount,
          },
        });
      }
    },
    *agentSalesInvoicePay4UserBsnl({ payload }, { call }) {
      const { params } = payload;
      const response = yield call(agentSalesInvoicePay4UserBsnl, params);
      return getRequestData(response, false);
    },
    *checkStaffOtpFlag({ payload }, { call, put }) {
      const response = yield call(checkStaffOtpFlag, payload);
      const { otpFlag } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          otpFlag,
        },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
